import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const mmkTheme = createTheme({
  palette: {
    primary: {
      main: grey[900],
    },
  },
});
